import React, { FC } from 'react';
import { Medium } from "@/constants/mediums";
import ReadingsPage from "@/components/readings/ReadingsPage";

const GasReadingsPage: FC = () => {
  return <ReadingsPage medium={Medium.gas} />;
};

export default GasReadingsPage;
